module.exports = __webpack_public_path__ + "img/beeline.fbea0e66.png";